import React from 'react'
import '../Assets/Css/webfooter.css'
import { Col, Container, Row } from 'react-bootstrap'
import { FaLocationDot } from "react-icons/fa6";
import { FaMobileAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaFacebookF } from "react-icons/fa6";
import { IoLogoYoutube } from "react-icons/io";
import { FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";



export default function WebFooter() {


  return (
    <>

      <Col lg={12}>
        <div className='p-1 ' style={{ backgroundColor: '#121417' }}>
          <Container>
            <Row className='mt-3'>
              <Col lg={5}  >
                <h5 style={{ color: '#DCAB34' }}> Office</h5>
                
                <div className='text-white' >
                  <FaLocationDot color='white' />  C-9, Twin Tower, Jambhulkar Chowk, Wanwadi, Pune – 411040
                </div>
              </Col>

              <Col lg={3}>
                <h5 style={{ color: '#DCAB34' }}>Contact</h5>

                <div className='mb-2 '>
                  <a
                    href="https://wa.me/7798737751 "
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    <span className='text-white'>

                      <FaMobileAlt color='white' />  +91 7798737751

                    </span>
                  </a>
                </div>

                <div className='d-flex '>
                  <a
                    href="mailto:contact@sumanikservices.com"
                    style={{ textDecoration: 'none', color: 'inherit', display: 'inline-flex', alignItems: 'center', gap: '6px' }}
                  >
                    <span className='text-white'>
                      < MdEmail color='white' />  contact@sumanikservices.com
                    </span>
                  </a>

                </div>

              </Col>

              <Col lg={4}>
                <h5 style={{ color: '#DCAB34' }}>Connect With us</h5>

                <p className='text-white' >
                  We’re always looking to connect with those who share an interest
                  in a sustainable future.
                </p>

                <div className='d-flex '>

                  <a className='iconback' href="https://www.facebook.com/Sumanikservices/">
                    <FaFacebookF />
                  </a>
                  <a className='iconback mx-2' href='#'>
                    <IoLogoYoutube />
                  </a>
                  <a className='iconback mx-1' href='#'>
                    <FaInstagram />
                  </a>
                  <a className='iconback mx-1' href='#'>
                    <FaXTwitter />
                  </a>

                </div>

              </Col>
            </Row>

            <div className='text-white mt-3 footerend text-center'>
              <hr />
              <p>© {new Date().getFullYear()} Sumanik Security and Allied Services Pvt Ltd |
                 <a href="https://www.bighostindia.in/" style={{ color: 'white', textDecoration: 'none' }}> Design By : BigHost India Private Limited</a> </p>
            </div>
          </Container>
        </div>
      </Col>
    </>
  )
}
